/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type FindBadgeRegistrationAttendeeQueryVariables = Types.Exact<{
  email?: Types.Maybe<Types.Scalars["String"]>;
  badgeCode?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type FindBadgeRegistrationAttendeeQuery = {
  findBadgeRegistrationAttendee: Pick<
    Types.BadgeRegistrationAttendee,
    | "userId"
    | "eventAttendeeId"
    | "claimId"
    | "claimStage"
    | "role"
    | "badgeCode"
    | "accountEmail"
    | "badgeDisplayName"
    | "interests"
    | "networkingEmail"
    | "networkingPhone"
    | "networkingLinkedIn"
    | "networkingDiscord"
    | "networkingInstagram"
    | "networkingX"
  > & {
    registrationData: Pick<
      Types.EventAttendeeRegistrationInfo,
      | "preferredName"
      | "legalName"
      | "pronouns"
      | "accessibilityNeeds"
      | "shirtType"
      | "shirtSize"
      | "shirtAccommodations"
    >;
    waiver: Pick<
      Types.BadgeRegistrationWaiverStatus,
      "signed" | "signedAt" | "signer"
    >;
  };
};

export const FindBadgeRegistrationAttendeeDocument = gql`
  query FindBadgeRegistrationAttendee($email: String, $badgeCode: String) {
    findBadgeRegistrationAttendee(email: $email, badge_code: $badgeCode) {
      userId
      eventAttendeeId
      claimId
      claimStage
      role
      badgeCode
      accountEmail
      registrationData {
        preferredName
        legalName
        pronouns
        accessibilityNeeds
        shirtType
        shirtSize
        shirtAccommodations
      }
      badgeDisplayName
      interests
      networkingEmail
      networkingPhone
      networkingLinkedIn
      networkingDiscord
      networkingInstagram
      networkingX
      waiver {
        signed
        signedAt
        signer
      }
    }
  }
`;

/**
 * __useFindBadgeRegistrationAttendeeQuery__
 *
 * To run a query within a React component, call `useFindBadgeRegistrationAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBadgeRegistrationAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBadgeRegistrationAttendeeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      badgeCode: // value for 'badgeCode'
 *   },
 * });
 */
export function useFindBadgeRegistrationAttendeeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FindBadgeRegistrationAttendeeQuery,
    FindBadgeRegistrationAttendeeQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    FindBadgeRegistrationAttendeeQuery,
    FindBadgeRegistrationAttendeeQueryVariables
  >(FindBadgeRegistrationAttendeeDocument, baseOptions);
}
export function useFindBadgeRegistrationAttendeeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FindBadgeRegistrationAttendeeQuery,
    FindBadgeRegistrationAttendeeQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    FindBadgeRegistrationAttendeeQuery,
    FindBadgeRegistrationAttendeeQueryVariables
  >(FindBadgeRegistrationAttendeeDocument, baseOptions);
}
export type FindBadgeRegistrationAttendeeQueryHookResult = ReturnType<
  typeof useFindBadgeRegistrationAttendeeQuery
>;
export type FindBadgeRegistrationAttendeeLazyQueryHookResult = ReturnType<
  typeof useFindBadgeRegistrationAttendeeLazyQuery
>;
export type FindBadgeRegistrationAttendeeQueryResult =
  ApolloReactCommon.QueryResult<
    FindBadgeRegistrationAttendeeQuery,
    FindBadgeRegistrationAttendeeQueryVariables
  >;
